var _path, _g, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEnglishFlag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_10408)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1_10408",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 25,
    height: 25
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.5 0.5H0.5V24.5H24.5V0.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1_10408)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5015 24.5008C15.1485 24.5039 17.7216 23.6277 19.8165 22.0098H5.18555C7.28084 23.6278 9.85423 24.504 12.5015 24.5008Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.83445 19.6089H22.1664C22.7053 18.8778 23.1592 18.0877 23.5194 17.2539H1.48145C1.84179 18.0876 2.2957 18.8777 2.83445 19.6089Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.953 0.591023C13.4716 0.53136 12.987 0.500638 12.502 0.499023V0.591023H13.953Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.732 14.8549H24.268C24.4223 14.0804 24.5 13.2926 24.5 12.5029H0.5C0.499951 13.2936 0.577658 14.0824 0.732 14.8579",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.502 10.0972H24.259C24.0947 9.28862 23.8467 8.49936 23.519 7.74219H12.502V10.0972Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.502 5.34628H22.136C21.4744 4.4576 20.6938 3.66416 19.816 2.98828H12.502V5.34628Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.502 0.59082V2.99082H19.818C18.1157 1.67756 16.0904 0.848374 13.956 0.59082H12.502Z",
    fill: "#E60012"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.502 7.74473H23.519C23.1516 6.89388 22.6868 6.0885 22.134 5.34473H12.502V7.74473Z",
    fill: "#E60012"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 12.3957H0.5C0.5 12.4307 0.5 12.4647 0.5 12.4957H24.5C24.5005 11.6897 24.4201 10.8857 24.26 10.0957H12.5V12.3957Z",
    fill: "#E60012"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.47942 17.2555H23.5184C23.8516 16.484 24.1023 15.6796 24.2664 14.8555H0.732422C0.896414 15.6796 1.14614 16.4841 1.47942 17.2555Z",
    fill: "#E60012"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.18498 22.0094H19.816C20.7077 21.3229 21.4991 20.5151 22.167 19.6094H2.83398C3.50192 20.5151 4.29325 21.3229 5.18498 22.0094Z",
    fill: "#E60012"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.8404 0.617188L10.7744 0.625187H10.8374L10.8404 0.617188Z",
    fill: "#1D2088"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5009 10.099V0.499023C12.076 0.499051 11.6515 0.521415 11.2289 0.566023L11.2479 0.624023H11.9089L11.3749 1.01302L11.5749 1.64202L11.0429 1.25702L10.5079 1.64502L10.7079 1.01602L10.2839 0.707023C9.395 0.872084 8.52775 1.13779 7.69893 1.49902L7.74493 1.64202L7.60593 1.54202C7.01496 1.80654 6.44643 2.11856 5.90593 2.47502H6.16093L5.62693 2.86402L5.82693 3.49302L5.29193 3.10502L4.75793 3.49902L4.82993 3.27602C4.58193 3.48202 4.34393 3.69902 4.11293 3.92502H4.24293L3.78393 4.25402L3.71193 4.33002L3.91193 4.94002L3.46093 4.61302C2.37771 5.85033 1.56076 7.29735 1.06093 8.86402H1.25493L1.45993 8.23502L1.66493 8.86402H2.32593L1.79193 9.25302L1.99193 9.88202L1.45993 9.49902L0.92493 9.88702L1.12493 9.25802L0.98393 9.14502C0.674991 10.2025 0.513137 11.2974 0.50293 12.399H12.5029L12.5009 10.099ZM11.5779 8.23402L11.0429 7.84702L10.5079 8.23402L10.7079 7.60502L10.1739 7.21602H10.8349L11.0399 6.58802L11.2449 7.21602H11.9059L11.3719 7.60502L11.5779 8.23402ZM5.08393 8.86402L5.28893 8.23502L5.49393 8.86402H6.15493L5.62093 9.25302L5.82093 9.88202L5.29293 9.49902L4.75793 9.88702L4.95793 9.25802L4.42393 8.86902L5.08393 8.86402ZM6.87393 7.60602L6.34393 7.21702H7.00393L7.20893 6.58902L7.40893 7.21702H8.06993L7.53593 7.60602L7.73593 8.23502L7.20093 7.84802L6.66593 8.23502L6.87393 7.60602ZM7.74093 4.94002L7.20593 4.55202L6.67093 4.94002L6.87093 4.31102L6.34393 3.92202H7.00393L7.20893 3.29402L7.40893 3.92202H8.06993L7.53593 4.31102L7.74093 4.94002ZM9.66193 9.88302L9.12593 9.49902L8.58993 9.88702L8.78993 9.25802L8.25593 8.86902H8.91693L9.12193 8.24002L9.32693 8.86902H9.98793L9.45393 9.25802L9.66193 9.88302ZM9.33193 5.56802H9.99293L9.45893 5.95702L9.65893 6.58602L9.12593 6.19902L8.58993 6.58702L8.78993 5.95802L8.25993 5.56902H8.92093L9.12593 4.94102L9.33193 5.56802ZM11.5779 4.94002L11.0429 4.55202L10.5079 4.94002L10.7079 4.31102L10.1739 3.92202H10.8349L11.0399 3.29402L11.2449 3.92202H11.9059L11.3719 4.31102L11.5779 4.94002ZM8.25993 2.47702H8.92093L9.12593 1.84902L9.33093 2.47702H9.99193L9.45793 2.86602L9.65793 3.49502L9.12293 3.10702L8.59093 3.49902L8.79093 2.87002L8.25993 2.47702ZM5.29293 4.94002L5.49793 5.56802H6.15893L5.62493 5.95702L5.82493 6.58602L5.29293 6.19902L4.75793 6.58702L4.95793 5.95802L4.42693 5.56902H5.08393L5.29293 4.94002ZM2.51093 7.21702H3.17193L3.37693 6.58902L3.58193 7.21702H4.24293L3.70893 7.60602L3.90893 8.23502L3.37393 7.84802L2.83893 8.23502L3.03893 7.60602L2.51093 7.21702ZM3.91093 11.53L3.37593 11.142L2.84093 11.53L3.04093 10.901L2.50693 10.512H3.16793L3.37293 9.88402L3.57793 10.512H4.23893L3.70493 10.901L3.91093 11.53ZM7.74393 11.53L7.20893 11.142L6.67393 11.53L6.87393 10.901L6.33993 10.512H7.00393L7.20893 9.88402L7.40893 10.512H8.06993L7.53593 10.901L7.74393 11.53ZM11.5769 11.53L11.0419 11.142L10.5069 11.53L10.7069 10.901L10.1729 10.512H10.8339L11.0389 9.88402L11.2439 10.512H11.9049L11.3709 10.901L11.5769 11.53Z",
    fill: "#0B318F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.507 1.64536L11.042 1.25736L11.577 1.64536L11.377 1.01636L11.911 0.627359H11.25L11.229 0.568359C11.099 0.582359 10.969 0.600359 10.84 0.617359V0.625359H10.777C10.613 0.649359 10.452 0.677359 10.29 0.707359L10.713 1.01636L10.507 1.64536Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.69944 1.50195L7.60645 1.54395L7.74545 1.64395L7.69944 1.50195Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2468 3.92097L11.0418 3.29297L10.8368 3.92097H10.1758L10.7098 4.31097L10.5098 4.93997L11.0448 4.55197L11.5798 4.93997L11.3798 4.31097L11.9138 3.92097H11.2468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.11311 3.91699C4.00211 4.02599 3.89411 4.13599 3.78711 4.24999L4.24311 3.91699H4.11311Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.71396 4.33008C3.62796 4.42308 3.54296 4.51808 3.45996 4.61308L3.91096 4.94008L3.71396 4.33008Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.41382 3.92097L7.21382 3.29297L7.00882 3.92097H6.34082L6.87482 4.31097L6.67482 4.93997L7.20982 4.55197L7.74482 4.93997L7.54482 4.31097L8.07882 3.92097H7.41382Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.9078 7.21687H11.2468L11.0418 6.58887L10.8368 7.21687H10.1758L10.7098 7.60587L10.5098 8.23487L11.0448 7.84787L11.5798 8.23487L11.3798 7.60587L11.9078 7.21687Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.8407 8.23487L3.3757 7.84787L3.91069 8.23487L3.7107 7.60587L4.2447 7.21687H3.5837L3.3787 6.58887L3.17369 7.21687H2.5127L3.04669 7.60587L2.8407 8.23487Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.74082 8.23487L7.54082 7.60587L8.07482 7.21687H7.41382L7.21382 6.58887L7.00882 7.21687H6.34082L6.87482 7.60587L6.67482 8.23487L7.20982 7.84787L7.74082 8.23487Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.2468 10.5118L11.0418 9.88379L10.8368 10.5118H10.1758L10.7098 10.9018L10.5098 11.5308L11.0448 11.1438L11.5798 11.5308L11.3798 10.9018L11.9138 10.5118H11.2468Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.58174 10.5118L3.37674 9.88379L3.17174 10.5118H2.51074L3.04474 10.9018L2.84474 11.5308L3.37974 11.1438L3.91474 11.5308L3.71474 10.9018L4.24874 10.5118H3.58174Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.41382 10.5118L7.21382 9.88379L7.00882 10.5118H6.34082L6.87482 10.9018L6.67482 11.5308L7.20982 11.1438L7.74482 11.5308L7.54482 10.9018L8.07882 10.5118H7.41382Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.42969 5.5694L4.96369 5.9594L4.76369 6.58841L5.29869 6.20041L5.83369 6.58841L5.63369 5.9594L6.16769 5.5694H5.50669L5.30169 4.94141L5.09669 5.5694H4.42969Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.91979 5.56843H8.25879L8.79279 5.95743L8.59279 6.58643L9.12879 6.19843L9.66379 6.58643L9.46379 5.95743L9.99779 5.56843H9.33679L9.13179 4.94043L8.91979 5.56843Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.75769 9.88333L5.29269 9.49533L5.82769 9.88333L5.62769 9.25433L6.16169 8.86533H5.50069L5.29569 8.23633L5.09069 8.86533H4.42969L4.96369 9.25433L4.75769 9.88333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.921875 9.88333L1.45688 9.49533L1.99188 9.88333L1.79188 9.25433L2.32588 8.86533H1.66588L1.46088 8.23633L1.25588 8.86533H1.06288C1.03288 8.95833 1.00688 9.05233 0.978875 9.14633L1.12788 9.25533L0.921875 9.88333Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.33076 8.86435L9.12577 8.23535L8.92076 8.86435H8.25977L8.79377 9.25435L8.59377 9.88335L9.12976 9.49535L9.66476 9.88335L9.46476 9.25435L9.99876 8.86435H9.33076Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.29184 3.10754L5.82683 3.49554L5.62683 2.86654L6.16084 2.47754H5.90283C5.53022 2.72401 5.17167 2.99109 4.82884 3.27754L4.75684 3.50054L5.29184 3.10754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.59067 3.49659L9.12667 3.10859L9.66167 3.49659L9.46167 2.86759L9.99567 2.47859H9.33467L9.12967 1.85059L8.92467 2.47859H8.26367L8.79767 2.86759L8.59067 3.49659Z",
    fill: "white"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 24.5C19.1274 24.5 24.5 19.1274 24.5 12.5C24.5 5.87258 19.1274 0.5 12.5 0.5C5.87258 0.5 0.5 5.87258 0.5 12.5C0.5 19.1274 5.87258 24.5 12.5 24.5Z",
    stroke: "#BCD6E6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_10408"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 25,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnglishFlag);
export default __webpack_public_path__ + "static/media/english-flag.7955ffacb3bef64a381f4a6417b83ac5.svg";
export { ForwardRef as ReactComponent };